import styled from "styled-components";

export default styled.div`
  padding: 3vw 6vw 3vw 6vw;

  .hero {
    border-radius: 6px;
  }
  .postImg {
    cursor: pointer;
  }
  .card {
    .card-content {
      height: 230px;
    }
    .card-image {
      img {
        object-fit: cover;
      }
    }
  }
  .contract {
    display: flex;
    flex-direction: row;
    align-items: center;
    img {
      cursor: pointer;
      margin-right: 30px;
    }
  }
`;
